import React from "react";
import { Switch, Route } from "react-router-dom";

import CompaniesPage from "./CompaniesPage";
import CompanyPage from "./CompanyPage";

const CompanyRouter = () => (
  <Switch>
    <Route path="/admin/company/:id">
      <CompanyPage />
    </Route>
    <Route path="/admin/company">
      <CompaniesPage />
    </Route>
  </Switch>
);

export default CompanyRouter;
